import { OnInit, Component, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
    selector: 'app-historico-endereco-pj',
    templateUrl: './historico-endereco-pj.component.html',
    styleUrls: ['./../cadastral-pj/cadastral-pj.component.css']
})

export class HistoricoEnderecoPjComponent implements OnInit {

    @Input() dados:any;

    public txtButtonConsultar:string='Consultar agora';
    public consultando:Boolean=false;
    public naoSolicitou:Boolean=false;
    public naoEncontrouRegistros:Boolean=false;
    public modalRef:BsModalRef;

    constructor(private modalService:BsModalService) {}

    ngOnInit(): void {
        
        if(this.dados.historico_endereco === undefined){
            this.naoSolicitou = true;
        } else if(this.dados.historico_endereco === null) {
            this.naoEncontrouRegistros = true;
        }
    }
}